import { Component } from '@verndale/core';
import { LoadSequenceBasic } from '../../helpers/animations';

class LanguageBtnDesktop extends Component {
  openClass = 'language-btn__menu--open';
  openBtnClass = 'language-btn__btn--open';
  navOpen = false;

  setupDefaults() {
    this.dom = {
      $openBtn: this.el.querySelector<HTMLElement>('.language-btn__btn'),
      $navMenu: this.el.querySelector<HTMLElement>('.language-btn__menu'),
      $menuList: this.el.querySelector<HTMLElement>('.language-btn__menu-list'),
      $menuItems: this.el.querySelectorAll<HTMLElement>('.language-btn__menu-item'),
      $menuLinks: this.el.querySelectorAll<HTMLElement>('.language-btn__menu-item .button--slide-bg:not(.button--slide-bg-active)'),
      $whiteArrow: this.el.querySelector<HTMLElement>('.language-btn__chevron-icon--white'),
      $colorArrow: this.el.querySelector<HTMLElement>('.language-btn__chevron-icon--color')
    };
  }

  addListeners() {
    (this.dom.$openBtn as HTMLElement)?.addEventListener('click', this.toggleNav.bind(this));

    window.addEventListener('DESKTOP_NAV_OPEN', this.handleDesktopNavOpen.bind(this));
    window.addEventListener('DESKTOP_SEARCH_OPEN', this.handleDesktopNavOpen.bind(this));
    window.addEventListener('DESKTOP_LANG_KEYDOWN', this.handleDesktopSearchKeyDown.bind(this));

    this.el.addEventListener('keydown', this.handleLangMenuKeyDown.bind(this));
  }

  toggleNav(e?: Event) {
    this.navOpen = !this.navOpen;
    (this.dom.$navMenu as HTMLElement)?.classList.toggle(this.openClass);
    (this.dom.$openBtn as HTMLElement)?.classList.toggle(this.openBtnClass);
    (this.dom.$menuList as HTMLElement)?.setAttribute('aria-expanded', String(this.navOpen));

    // notify language menu is open
    if (this.navOpen) {
      const event = new CustomEvent('LANG_MENU_OPEN', { bubbles: true });
      window.dispatchEvent(event);

      this.animateIn();

      const pe = e as PointerEvent;
      // if keyboard triggered, focus first item
      if (!pe.clientX || (pe.clientX === 0 && pe.clientY === 0)) {
        const firstFocusable = this.el.querySelector('.language-btn__menu-item .button--slide-bg:not(.button--slide-bg-active)') as HTMLElement;
        firstFocusable?.focus();
      }
      (this.dom.$whiteArrow as HTMLElement).style.transform = 'rotate(270deg)';
      (this.dom.$whiteArrow as HTMLElement).style.display = 'block';
      (this.dom.$colorArrow as HTMLElement).style.display = 'none';
    } else {
      (this.dom.$openBtn as HTMLElement).blur();
      (this.dom.$whiteArrow as HTMLElement).removeAttribute('style');
      (this.dom.$colorArrow as HTMLElement).removeAttribute('style');
    }
  }

  handleDesktopSearchKeyDown(e: Event) {
    if (!this.navOpen) this.toggleNav(e);
  }

  handleDesktopNavOpen() {
    if (!this.navOpen) {
      return;
    }

    this.toggleNav();
  }

  handleLangMenuKeyDown(e: Event) {
    const ke = e as KeyboardEvent;
    const key = ke.key;

    if (key === 'ArrowUp' || key === 'ArrowDown') {
      ke.preventDefault();

      const menuLinks = this.dom.$menuLinks as NodeListOf<HTMLElement>;
      const activeItem = document.activeElement as HTMLElement;
      const activeIndex = Array.from(menuLinks).indexOf(activeItem);
      const nextIndex = key === 'ArrowUp' ? activeIndex - 1 : activeIndex + 1;

      if (nextIndex >= 0 && nextIndex < menuLinks.length) {
        const nextItem = menuLinks[nextIndex];
        nextItem.focus();
      } else if (key === 'ArrowUp' && activeIndex === 0) {
        (this.dom.$openBtn as HTMLElement).focus();
      }
    }
  }

  animateIn() {
    const navMenu = this.dom.$navMenu as HTMLElement;
    const menuItems = this.dom.$menuItems as NodeListOf<HTMLElement>;
    const elements = [
      { element: navMenu, addScale: false, offset: 0 }
    ];

    menuItems.forEach((item, index) => {
      elements.push({ element: item, addScale: false, offset: 0.3 + (index * 0.05) });
    });

    LoadSequenceBasic(elements);
  }
}

export default LanguageBtnDesktop;
